<template>
    <svg :id="idName" style="width:100%;height: 300px"></svg>
</template>

<script>
import { Transformer } from 'markmap-lib';
import { Markmap } from 'markmap-view';

export default {
  name: 'MarkdownRenderer',
  props: {
    content: {
      type: String,
      required: true,
    },
    idName: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.renderMarkmap();
  },
  watch: {
    content() {
      this.$nextTick(this.renderMarkmap());
    },
  },
  methods: {
    renderMarkmap() {
      if (!this.content) return;

      const transformer = new Transformer();
      const { root } = transformer.transform(this.content);
      Markmap.create('#'+this.idName,null, root)
    },
  },
};
</script>

